import { render, staticRenderFns } from "./ProdAbnormalEdit.vue?vue&type=template&id=2805d662&"
import script from "./ProdAbnormalEdit.vue?vue&type=script&lang=js&"
export * from "./ProdAbnormalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports